var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg89(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.49,34.74H33.6c0,0,6.49-6.9,1.59-15.04c0,0-4.54-8.02-13.51-6.31c0,0-9.14,1.43-10.5,11.83 C11.19,25.22,10.36,30.08,14.49,34.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.43,32.79h17.1c0,0,6.55-8.02-1.89-15.39c0,0-8.2-6.37-15.45,2.24C15.2,19.64,10.48,25.71,15.43,32.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.14,25.22l4.16-6.31c0,0,1.77-0.92,1.59,0.85l-4.31,6.84c0,0,1.83,3.36-1.71,4.78c0,0-4.72,0.24-3.42-4.54 C21.45,26.83,22.28,24.97,25.14,25.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24,23.95c0,0-5.31-1.5-5.54,4.78c0,0,0.53,6.39,7.49,3.62c0,0,1.18,0.29,0.47,1.47c0,0-6.25,3.72-9.67-3.6 c0,0-1.71-4.52,3.18-7.54c0,0,1.95-1.39,5.13-0.76C9.3,21.92,10.6,23.51,8.24,23.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.99,23.96c0,0,5.28-1.51,5.51,4.81c0,0-0.53,6.44-7.45,3.64c0,0-1.17,0.29-0.47,1.48c0,0,6.22,3.74,9.62-3.62 c0,0,1.7-4.55-3.17-7.59c0,0-1.94-1.4-5.1-0.77C38.94,21.92,37.65,23.53,39.99,23.96z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 24.03,
    cy: 28.67,
    r: 1.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.03,19.17L24.03,19.17c-0.61,0-1.11-0.5-1.11-1.11v-0.83c0-0.61,0.5-1.11,1.11-1.11h0c0.61,0,1.11,0.5,1.11,1.11v0.83 C25.14,18.67,24.64,19.17,24.03,19.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.61,21.83L18.61,21.83c-0.46,0.4-1.16,0.36-1.56-0.1l-0.55-0.62c-0.4-0.46-0.36-1.16,0.1-1.56l0,0 c0.46-0.4,1.16-0.36,1.56,0.1l0.55,0.62C19.11,20.73,19.07,21.43,18.61,21.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.85,26.73L16.85,26.73c-0.03,0.61-0.55,1.08-1.16,1.05l-0.83-0.04c-0.61-0.03-1.08-0.55-1.05-1.16v0 c0.03-0.61,0.55-1.08,1.16-1.05l0.83,0.04C16.41,25.6,16.88,26.12,16.85,26.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.19,26.73L34.19,26.73c-0.03,0.61-0.55,1.08-1.16,1.05l-0.83-0.04c-0.61-0.03-1.08-0.55-1.05-1.16v0 c0.03-0.61,0.55-1.08,1.16-1.05l0.83,0.04C33.75,25.6,34.22,26.12,34.19,26.73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg89);
export default __webpack_public_path__ + "static/media/89.b888aa32475b10c63d727aecd70a66ed.svg";
export { ForwardRef as ReactComponent };